import { BehaviorSubject, filter, fromEvent, map, skip, tap } from "rxjs";
import { getComponentElement } from "./baseComponent.helpers";
import { HTMLElementAttribute, HTMLElementEventType } from "./misc.enums";
import { Slugs } from "./slug.loader";
import { sendInteractionMetrics } from "../../login/src/formHelpers/metricsHelper";
import { UIAction, UIType } from "./cdpaRequest";
var CdpaInputQuerySelector;
(function (CdpaInputQuerySelector) {
    CdpaInputQuerySelector["Base"] = ".cdpa-checkbox";
    CdpaInputQuerySelector["Message"] = ".cdpa-checkbox__message";
    CdpaInputQuerySelector["MessageWrapper"] = ".cdpa-checkbox__message-wrapper";
    CdpaInputQuerySelector["Tooltip"] = ".cdpa-tooltip";
})(CdpaInputQuerySelector || (CdpaInputQuerySelector = {}));
var CdpaInputClassModifier;
(function (CdpaInputClassModifier) {
    CdpaInputClassModifier["Invalid"] = "cdpa-checkbox--invalid";
})(CdpaInputClassModifier || (CdpaInputClassModifier = {}));
export class CdpaCheckboxComponent {
    constructor(elementId) {
        this.inputElement = getComponentElement(document.getElementById(elementId));
        this.parentElement = getComponentElement(this.inputElement.closest(CdpaInputQuerySelector.Base));
        this.errorMessageElement = getComponentElement(this.parentElement.querySelector(CdpaInputQuerySelector.Message));
        this.errorMessageWrapperElement = getComponentElement(this.parentElement.querySelector(CdpaInputQuerySelector.MessageWrapper));
        if (this.parentElement.hasAttribute(HTMLElementAttribute.DataIsInvalid)) {
            this.setValidity(false);
            this.label = this.parentElement.getAttribute(HTMLElementAttribute.DataLabel) ?? "";
        }
        this.valueSubject = new BehaviorSubject(this.inputElement.checked);
        this.value$ = this.valueSubject.asObservable();
        fromEvent(this.inputElement, HTMLElementEventType.Change)
            .pipe(map(() => this.inputElement.checked), tap((isChecked) => {
            sendInteractionMetrics(this.inputElement, UIType.Checkbox, isChecked ? UIAction.Enable : UIAction.Disable);
        }))
            .subscribe((isChecked) => {
            this.valueSubject.next(isChecked);
        });
        this.subscribeValidators();
    }
    getValue() {
        return this.valueSubject.getValue();
    }
    validate() {
        const isValid = this.getValue();
        this.setValidity(isValid);
        return isValid;
    }
    setValidity(isValid) {
        this.updateValidityClass(isValid);
        this.showErrorMessage(isValid);
    }
    updateValidityClass(isValid) {
        if (isValid) {
            this.parentElement.classList.remove(CdpaInputClassModifier.Invalid);
        }
        else {
            this.parentElement.classList.add(CdpaInputClassModifier.Invalid);
        }
    }
    showErrorMessage(isValid) {
        this.label = Slugs.translated.agreementRequired;
        const cdpaInputLabelHidden = "cdpa-checkbox__message-wrapper--hidden";
        if (isValid) {
            this.errorMessageWrapperElement.classList.add(cdpaInputLabelHidden);
        }
        else {
            this.errorMessageWrapperElement.classList.remove(cdpaInputLabelHidden);
        }
    }
    subscribeValidators() {
        this.value$
            .pipe(skip(1), filter((value) => !!value))
            .subscribe(() => {
            this.validate();
        });
    }
    set label(value) {
        this.errorMessageElement.innerHTML = value;
    }
}
